import { addDays, isSameDay, startOfDay } from "date-fns";

import type { BookableAssetDetailDto } from "@/api/types";

export function getMinBookingDate(asset: BookableAssetDetailDto | undefined, now: Date): Date {
  if (!asset) {
    return now;
  }

  const publishAt = asset.publishAt ? new Date(asset.publishAt) : now;
  let availableFrom = asset.availableFrom ? new Date(asset.availableFrom) : now;
  availableFrom = publishAt > availableFrom ? publishAt : availableFrom;
  availableFrom = availableFrom < now ? now : availableFrom;

  if (!asset.canBookSameDay && isSameDay(now, availableFrom)) {
    return startOfDay(addDays(now, 1));
  }

  return availableFrom;
}

export function getMaxBookingDate(asset: BookableAssetDetailDto | undefined, now: Date): Date {
  if (!asset) {
    return now;
  }

  const unpublishAt = asset.unpublishAt ? new Date(asset.unpublishAt) : undefined;
  const maxDaysInAdvance = addDays(now, asset.maxDaysInAdvance ? asset.maxDaysInAdvance - 1 : 364);

  return unpublishAt && unpublishAt < maxDaysInAdvance ? unpublishAt : maxDaysInAdvance;
}
